import React, { useEffect, useMemo, useRef, useState } from "react";
import Map from "../../../../components/molecules/Map/Map";
import L from 'leaflet'
import markerImage from '../../../../components/molecules/Map/assets/red_icon.png'
import markerCmionIcon from '../../../../components/molecules/Map/assets/camion.png'
import markerCmionAliadoIcon from '../../../../assets/icons/unidadAliado.png'
import { Marker, Polyline, Popup } from "react-leaflet";
import { getTrazo, getUnidades } from "./integracionPanel";
import { getClients, getZonas } from "../../MonitoreoServicios/MonitoreoServiciosIntegracion";
import LineaDeTiempo from "../../../../components/molecules/LineaDeTiempo/LineaDeTiempo";
import CentrarMapa from "../CentrarMapa";
import Filtros from "./Filtros";

const PanelMapaVistaServicios = ({
    setDataUnidad,
    dataUnidad,
    setRutas,
    listaRutasPanelIzquierdo,
    setContadorPorMinuto,
    contadorPorMinuto,
    centrarUnidad,
    setUnidades,
    unidades,
    zona,
    setZona,
    cliente,
    setCliente,
    tipoServicio,
    setTipoServicio,
    activeIndex,
    setUnidadSeleccionada,
    unidadSeleccionada,
    servicios,
    confirmadoNoConfirmado,
    setConfirmadoNoConfirmado,
}) => {
    // Estados principales
    const [defaultCenter, setDefaultCenter] = useState({ lat: 20.67129241646564, lng: -103.35232101509537 });
    const [selectRutas, setSelectRutas] = useState(null);
    const [previousUnidadesRef, setPreviousUnidadesRef] = useState({});
    const [clientes, setCleintes] = useState([]);
    const [paradasIndex, setParadasIndex] = useState();
    const [polilineaSeleccionada, setPolilineaSeleccionada] = useState();
    const [trazo, setTrazo] = useState([]);
    const [bitacorasus, setBitacoras] = useState(null);
    const [trazoLineaDelTiempo, setTrazoLineaDelTiempo] = useState(null);
    const [zonas, setZonas] = useState([]);
    const [actualizador, setActualizador] = useState(false);
    const [actualizadorTrazo, setActualizadorTrazo] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [zoom, setZoom] = useState(13);
    const [previousZoom, setPreviousZoom] = useState(13);
    const [temaMapa, setTemaMapa] = useState({ name: "CLARO", code: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png?key=cb1_272a_1_35c523a1879227e1480394f9' });

    // FILTROS
    const [cambiarVista, setCambiarVista] = useState(false);
    const [mostrarTrazos, setMostrarTrazos] = useState(true);
    const [isFiltersExpanded, setIsFiltersExpanded] = useState(false);

    // Referencias para AbortController y Map
    const abortControllerRef = useRef(null);
    const trazoAbortControllerRef = useRef(null);
    const mapRef = useRef(null);
    const zoomTimeoutRef = useRef(null);
    const centeringTimeoutRef = useRef(null);


    // Detectar cambios en el zoom para desactivar transiciones
    useEffect(() => {
        if (zoom !== previousZoom) {
            const mapContainer = document.querySelector('.map-container');
            if (mapContainer) {
                mapContainer.classList.add('zoom-in-progress');


                // Reactivar transiciones después de un momento
                setTimeout(() => {
                    mapContainer.classList.remove('zoom-in-progress');

                }, 800);
            }
            setPreviousZoom(zoom);
        }
    }, [zoom, previousZoom]);

    // Hook para manejar eventos de zoom del mapa
    useEffect(() => {
        const handleZoomEvents = () => {
            const mapContainer = document.querySelector('.map-container');
            if (!mapContainer) return;

            const leafletContainer = mapContainer.querySelector('.leaflet-container');
            if (!leafletContainer) return;

            // Función para desactivar transiciones durante zoom
            const disableTransitions = () => {
                mapContainer.classList.add('zoom-in-progress');

            };

            // Función para reactivar transiciones después del zoom
            const enableTransitions = () => {
                if (zoomTimeoutRef.current) {
                    clearTimeout(zoomTimeoutRef.current);
                }

                zoomTimeoutRef.current = setTimeout(() => {
                    mapContainer.classList.remove('zoom-in-progress');

                }, 300);
            };

            // Escuchar eventos de zoom
            leafletContainer.addEventListener('wheel', disableTransitions, { passive: true });

            let zoomTimer;
            const handleZoomEnd = () => {
                clearTimeout(zoomTimer);
                zoomTimer = setTimeout(enableTransitions, 150);
            };

            leafletContainer.addEventListener('wheel', handleZoomEnd, { passive: true });

            // También escuchar clicks en los botones de zoom
            const zoomButtons = leafletContainer.querySelectorAll('.leaflet-control-zoom a');
            zoomButtons.forEach(button => {
                button.addEventListener('click', () => {
                    disableTransitions();
                    setTimeout(enableTransitions, 150);
                });
            });

            // Cleanup
            return () => {
                if (leafletContainer) {
                    leafletContainer.removeEventListener('wheel', disableTransitions);
                    leafletContainer.removeEventListener('wheel', handleZoomEnd);

                    const zoomButtons = leafletContainer.querySelectorAll('.leaflet-control-zoom a');
                    zoomButtons.forEach(button => {
                        button.removeEventListener('click', disableTransitions);
                    });
                }
                if (zoomTimeoutRef.current) {
                    clearTimeout(zoomTimeoutRef.current);
                }
            };
        };

        const timer = setTimeout(handleZoomEvents, 150);

        return () => {
            clearTimeout(timer);
            if (zoomTimeoutRef.current) {
                clearTimeout(zoomTimeoutRef.current);
            }
        };
    }, [activeIndex]);

    // Manejar centrado de unidad
    useEffect(() => {
        if (centrarUnidad && centrarUnidad[0] && centrarUnidad[1]) {


            const mapContainer = document.querySelector('.map-container');
            if (mapContainer) {
                mapContainer.classList.add('zoom-in-progress');

            }

            setZoom(16);

            if (centeringTimeoutRef.current) {
                clearTimeout(centeringTimeoutRef.current);
            }

            centeringTimeoutRef.current = setTimeout(() => {
                if (mapContainer) {
                    mapContainer.classList.remove('zoom-in-progress');
                }
            }, 1500);
        }

        return () => {
            if (centeringTimeoutRef.current) {
                clearTimeout(centeringTimeoutRef.current);
            }
        };
    }, [centrarUnidad]);

    // Efectos principales
    useEffect(() => {
        getZonas(setZonas);
        getClients(setCleintes, zona);
    }, []);

    useEffect(() => {
        if (zona) {
            getClients(setCleintes, zona);
        } else {
            setSelectRutas(null);
        }
    }, [zona]);

    useEffect(() => {
        const intervalo = setInterval(() => {
            if (contadorPorMinuto === 10) {
                setContadorPorMinuto(0);
            } else {
                setContadorPorMinuto(minutosAnteriores => minutosAnteriores + 1);
            }
        }, 60000);

        return () => clearInterval(intervalo);
    }, []);

    // efecto de la unidades - OPTIMIZADO con actualización automática
    useEffect(() => {
        if (activeIndex !== 0 || listaRutasPanelIzquierdo.length === 0) {
            setUnidades([]);
            setBitacoras(null);
            setTrazo([]);
            return;
        }

        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }

        const newAbortController = new AbortController();
        abortControllerRef.current = newAbortController;

        const getUnidadesFuncion = async () => {
            try {
                if ((!unidades || unidades.length === 0) && bitacorasus) {
                    setIsLoading(true);
                }

                if (bitacorasus) {


                    const handleUnidadesUpdate = (nuevasUnidades) => {
                   
                        setUnidades(prevUnidades => {
                            if (!nuevasUnidades || nuevasUnidades.length === 0) {
                                return prevUnidades;
                            }
                            return nuevasUnidades;
                        });

                        const unidadesRef = {};
                        nuevasUnidades.forEach(unidad => {
                            if (unidad.coordenadas) {
                                unidadesRef[unidad.ID_BITACORA] = {
                                    coordenadas: [...unidad.coordenadas]
                                };
                            }
                        });
                        setPreviousUnidadesRef(unidadesRef);

                        setTimeout(() => {
                            if (!newAbortController.signal.aborted) {

                                setActualizador(prev => !prev);
                            }
                        }, 1000);
                    };

                    const res = await getUnidades(
                        handleUnidadesUpdate,
                        bitacorasus,
                        tipoServicio?.code,
                        confirmadoNoConfirmado?.code,
                        actualizador,
                        newAbortController.signal
                    );
                    setActualizador(res);
                }
            } catch (error) {
                if (error.name !== 'AbortError') {
                    console.error('Error en la petición de unidades:', error);
                    setTimeout(() => {
                        if (!newAbortController.signal.aborted) {
                            setActualizador(prev => !prev);
                        }
                    }, 10000);
                }
            } finally {
                setIsLoading(false);
            }
        };

        getUnidadesFuncion();
        setRutas(listaRutasPanelIzquierdo);

        return () => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
        };
    }, [listaRutasPanelIzquierdo, bitacorasus, tipoServicio, confirmadoNoConfirmado, activeIndex, actualizador]);

    // Limpiar referencias cuando cambien las rutas seleccionadas
    useEffect(() => {
        setPreviousUnidadesRef({});
    }, [listaRutasPanelIzquierdo]);

    // Efecto para trazos - OPTIMIZADO
    useEffect(() => {
        if (activeIndex !== 0 || listaRutasPanelIzquierdo.length === 0) {
            setBitacoras(null);
            setTrazo([]);
            setParadasIndex([]);
            return;
        }

        if (trazoAbortControllerRef.current) {
            trazoAbortControllerRef.current.abort();
        }

        const newAbortController = new AbortController();
        trazoAbortControllerRef.current = newAbortController;

        const bitacoras = listaRutasPanelIzquierdo
            .map(ruta => ruta.id)
            .join(", ");

        setBitacoras(bitacoras);

        if (mostrarTrazos && bitacoras) {
            getTrazo(setTrazo, bitacoras, newAbortController.signal, setActualizadorTrazo, actualizadorTrazo);
        } else {
            setTrazo([]);
        }

        setParadasIndex([]);

        return () => {
            if (trazoAbortControllerRef.current) {
                trazoAbortControllerRef.current.abort();
            }
        };
    }, [listaRutasPanelIzquierdo, activeIndex, mostrarTrazos]);

    useEffect(() => {
        if (cambiarVista === true) {
            let convinados = [];

            for (let i = 0; i <= unidades.length - 1; i++) {
                for (let j = 0; j < trazo.length; j++) {
                    if (unidades[i].ID_BITACORA === trazo[j].ID_BITACORA) {
                        convinados.push({ ...unidades[i], ...trazo[j] });
                    }
                }
            }
            setTrazoLineaDelTiempo(convinados);
        }
    }, [unidades, trazo]);

    // Funciones de utilidad
    const markerPersonalizado = (item, key) => {
        return L.divIcon({
            className: "custom-marker",
            html: `
                <img style="width:40px;position:relative" src="${markerImage}"/>
                <div style="position:absolute;top:12px;left:${key < 10 ? "17px" : "14.5px"};font-weight:bold;font-size:0.6rem">${key}</div>
            `,
            iconSize: [25, 41],
            iconAnchor: [12, 41],
        });
    };

    const markerUnidad = new L.Icon({
        iconUrl: markerCmionIcon,
        iconSize: [50, 25],
        iconAnchor: [25, 12],
        popupAnchor: [0, -12],
    });

    const markerUnidadSeleccionada = new L.Icon({
        iconUrl: markerCmionIcon,
        iconSize: [50, 25],
        iconAnchor: [25, 12],
        popupAnchor: [0, -12],
        className: 'marker-selected-highlight' // Agregar clase CSS especial
    });
    const markerUnidadAliado = new L.Icon({
        iconUrl: markerCmionAliadoIcon,
        iconSize: [50, 25],
        iconAnchor: [25, 12],
        popupAnchor: [0, -12],
    });

    const handleUnidadClick = (data) => {

        const mapContainer = document.querySelector('.map-container');
        if (mapContainer) {
            mapContainer.classList.add('zoom-in-progress');

            setTimeout(() => {
                mapContainer.classList.remove('zoom-in-progress');

            }, 300);
        }

        setDataUnidad(data);
        setUnidadSeleccionada(null);
    };

    const handlepolilyne = (index, item) => {
        setParadasIndex(index);
        setPolilineaSeleccionada(item);
    };

    const clearAllFilters = () => {
        setZona(null);
        setCliente(null);
        setTipoServicio(null);
        setConfirmadoNoConfirmado(null);
        setSelectRutas(null);
        setMostrarTrazos(true);
    };

    // Componentes memoizados para optimización
    const memoizedMarkers = useMemo(() => {
        if (!unidades || unidades.length === 0) {
            return [];
        }

        return unidades
            .filter(unidaditem => unidaditem.coordenadas && unidaditem.coordenadas.length === 2)
            .map((unidaditem) => {
         
                
                let icon = unidaditem.PROVEEDOR === "SUMA" ? markerUnidad : markerUnidadAliado;
                let isHighlighted = false;
                
                if (dataUnidad && dataUnidad.UNIDAD == unidaditem.UNIDAD) {
                    icon = markerUnidadSeleccionada;
                    isHighlighted = true;
                }
                if(unidadSeleccionada && unidadSeleccionada.UNIDAD == unidaditem.UNIDAD){
                    icon = markerUnidadSeleccionada;
                    isHighlighted = true;
                    setDataUnidad(null);
                }

                return (
                    <Marker
                        key={`marker-${unidaditem.ID_BITACORA}`}
                        position={unidaditem.coordenadas}
                        icon={icon}
                        eventHandlers={{ 
                            click: () => handleUnidadClick(unidaditem),
                            add: (e) => {
                                // Agregar clase CSS adicional cuando se agrega el marcador seleccionado
                                if (isHighlighted) {
                                    setTimeout(() => {
                                        const markerElement = e.target._icon;
                                        if (markerElement) {
                                            markerElement.classList.add('marker-glow-effect');
                                        }
                                    }, 100);
                                }
                            }
                        }}
                        riseOnHover={true}
                        riseOffset={isHighlighted ? 1000 : 250}
                        zIndexOffset={isHighlighted ? 1000 : 0}
                    >
                        {/* <Popup>
                            <div className="popup-content">
                                <h4>Unidad {unidaditem.NUMERO_UNIDAD}</h4>
                                <hr />
                                <div className="popup-status">
                                    <span className={`status-badge ${unidaditem.CONFIRMADA === 'SI' ? 'confirmed' : 'unconfirmed'}`}>
                                        {unidaditem.CONFIRMADA === 'SI' ? "✅ Confirmada" : "⛔ No Confirmada"}
                                    </span>
                                </div>
                                <p><strong>Operador:</strong> {unidaditem.OPERADOR}</p>
                                <p><strong>Proveedor:</strong> {unidaditem.PROVEEDOR}</p>
                            </div>
                        </Popup> */}
                    </Marker>
                );
            });
    }, [unidades, dataUnidad, unidadSeleccionada]);

    const memoizedPolylines = useMemo(() => {
        if (!trazo || trazo.length === 0) {
            return [];
        }

        return trazo.map((item, key) => (
            <Polyline
                key={`polyline-${item.id}-${key}`}
                pathOptions={{ color: item.polylineColor, weight: 5 }}
                positions={item.trazo}
                eventHandlers={{ click: () => handlepolilyne(key, item) }}
            >
                <Popup>
                    <div className="popup-content">
                        <h4>{item.routeName}</h4>
                        <hr />
                        <div className="popup-status">
                            <span className={`status-badge ${item.confrimada ? 'confirmed' : 'unconfirmed'}`}>
                                {item.confrimada ? "✅ Confirmada" : "⛔ No Confirmada"}
                            </span>
                        </div>
                    </div>
                </Popup>
            </Polyline>
        ));
    }, [trazo]);

    const renderFilters = () => (
        <Filtros
            isFiltersExpanded={isFiltersExpanded}
            setIsFiltersExpanded={setIsFiltersExpanded}
            unidades={unidades}
            trazo={trazo}
            setMostrarTrazos={setMostrarTrazos}
            mostrarTrazos={mostrarTrazos}
            setCambiarVista={setCambiarVista}
            cambiarVista={cambiarVista}
            clearAllFilters={clearAllFilters}
            zona={zona}
            setZona={setZona}
            tipoServicio={tipoServicio}
            setTipoServicio={setTipoServicio}
            temaMapa={temaMapa}
            setTemaMapa={setTemaMapa}
            zonas={zonas}
            setZonas={setZonas}
            clientes={clientes}
            cliente={cliente}
            setSelectCliente={setCliente}
            setConfirmadoNoConfirmado={setConfirmadoNoConfirmado}
            confirmadoNoConfirmado={confirmadoNoConfirmado}
        />
    );

    return (
        <div className="panel-mapa-container">
            <div className="panel-header">
                {renderFilters()}
            </div>

            <div className="panel-content">
                {!cambiarVista ? (
                    <div className="map-container">
                        {isLoading && (!unidades || unidades.length === 0) && (
                            <div style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                zIndex: 1000,
                                background: 'rgba(0,0,0,0.8)',
                                color: 'white',
                                padding: '16px 24px',
                                borderRadius: '8px',
                                fontSize: '14px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}>
                                <i className="pi pi-spin pi-spinner"></i> Cargando unidades...
                            </div>
                        )}

                        <Map
                            center={centrarUnidad && centrarUnidad[0] && centrarUnidad[1] ? centrarUnidad : defaultCenter}
                            zoom={zoom}
                            scrollWheelZoom={true}
                            style={{ height: "100%" }}
                            temaMapa={temaMapa.code}
                            ref={mapRef}
                            whenReady={() => {
                                console.log('Mapa listo');
                            }}
                        >
                            <CentrarMapa lat={centrarUnidad[0]} lng={centrarUnidad[1]} zoom={zoom} />
                            {trazo.length > 0 && (
                                <>
                                    {trazo.map((item, key) => (
                                        <React.Fragment key={`trazo-${key}`}>
                                            {paradasIndex !== undefined && (
                                                <>
                                                    {selectRutas ? (
                                                        trazo[0]?.markers?.map((parada, indexParada) => (
                                                            <Marker
                                                                key={`parada-${indexParada}`}
                                                                position={parada?.marker}
                                                                icon={markerPersonalizado(parada, indexParada + 1)}
                                                            />
                                                        ))
                                                    ) : (
                                                        trazo[paradasIndex]?.markers?.map((parada, indexParada) => (
                                                            <Marker
                                                                key={`parada-${indexParada}`}
                                                                position={parada?.marker}
                                                                icon={markerPersonalizado(parada, indexParada + 1)}
                                                            />
                                                        ))
                                                    )}
                                                </>
                                            )}
                                        </React.Fragment>
                                    ))}
                                    {memoizedPolylines}
                                </>
                            )}
                            {memoizedMarkers}
                        </Map>
                    </div>
                ) : (
                    <div className="timeline-container">
                        <div className="timeline-header">
                            <h3>
                                <i className="pi pi-clock"></i>
                                Línea de Tiempo de Servicios
                            </h3>
                            <span className="timeline-count">
                                {trazoLineaDelTiempo?.length || 0} servicios activos
                            </span>
                        </div>
                        <div className="timeline-content">
                            {trazoLineaDelTiempo?.length > 0 ? (
                                trazoLineaDelTiempo.map((item, index) => (
                                    <LineaDeTiempo
                                        key={`timeline-${index}`}
                                        handleUnidadClick={handleUnidadClick}
                                        paradasTotales={item}
                                    />
                                ))
                            ) : (
                                <div className="no-data-message">
                                    <i className="pi pi-info-circle"></i>
                                    <h4>No hay datos disponibles</h4>
                                    <p>Ajusta los filtros para ver información de las rutas</p>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}


export default PanelMapaVistaServicios
